import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyAeVPSBHC1-FH5DqTU7tROB1mniA6nJ300",
  authDomain: "doris-firebase-sandbox.firebaseapp.com",
  databaseURL: "https://doris-firebase-sandbox.firebaseio.com",
  projectId: "doris-firebase-sandbox",
  storageBucket: "doris-firebase-sandbox.appspot.com",
  messagingSenderId: "865737789862",
  appId: "1:865737789862:web:35c20fb7136f9504e13f67"

}

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const firebaseDB = firebase.database();
const firebaseData = firebaseDB.ref();

export {
  firebase,
  firebaseDB,
  firebaseData,
}
